/**
 * Componente de Button
 * Botão reutilizável com diferentes variantes
 */

import { ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger'
  fullWidth?: boolean
  loading?: boolean
}

const variantStyles = {
  primary: 'bg-green-600 hover:bg-green-700 focus:ring-green-500',
  secondary: 'bg-gray-600 hover:bg-gray-700 focus:ring-gray-500',
  danger: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
}

export function Button({ 
  variant = 'primary', 
  fullWidth = false,
  loading = false,
  children,
  disabled,
  className = '',
  ...props 
}: ButtonProps) {
  return (
    <button
      className={`
        ${variantStyles[variant]}
        ${fullWidth ? 'w-full' : ''}
        rounded-lg px-4 py-3 font-semibold text-white shadow-lg 
        transition-all focus:outline-none focus:ring-2 focus:ring-offset-2
        disabled:cursor-not-allowed disabled:opacity-50
        ${className}
      `}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
          <span className="ml-2">Carregando...</span>
        </div>
      ) : (
        children
      )}
    </button>
  )
}
